module.exports = __webpack_public_path__ + "static/media/especialistas_testimonios9.b89402f5.jpeg";